import { render, staticRenderFns } from "./Chap25JsonAndXml.vue?vue&type=template&id=5bc958a4&scoped=true&"
import script from "./Chap25JsonAndXml.vue?vue&type=script&lang=js&"
export * from "./Chap25JsonAndXml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc958a4",
  null
  
)

export default component.exports